import { memo } from 'react';
import { SidePane } from '@library';
import styles from './ProductSearchSidePanel.module.scss';

const ProductSearchSidePanel = ({
    isOpen,
    toggle,
    children,
}: {
    isOpen: boolean;
    toggle: () => void;
    children?: React.ReactNode;
}) => {
    return (
        <SidePane open={isOpen} side="right" onOpenChange={toggle}>
            <div className={styles.container}>{children}</div>
        </SidePane>
    );
};

export default memo(ProductSearchSidePanel);
